import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import SUKLCertificateHint from './SUKLCertificateHint';
import { Size } from '../../../../Enums/Size.enum';

const SUKLCertificateHintModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			{...props}
			title='component.certificates.whatIsSUKL2'
			size={Size.LG}>
			<SUKLCertificateHint />
		</BaseModal>
	);
};

export default SUKLCertificateHintModal;
